const cfIdRegex = /(^CF\/(\S+))|(\sCF\/(\S+))/

// Return the ID from the correctional facility kiosk browser's User-Agent string. The format of the partial string in the User-Agent is CF/{FACILITY_ID}.
export default function getCorrectionalFacilityId() {
  const SERVER_DATA = typeof window !== 'undefined' && window?.SERVER_DATA

  if (SERVER_DATA?.correctionalFacilityId) {
    return SERVER_DATA.correctionalFacilityId
  }
  const userAgent = typeof navigator !== 'undefined' ? navigator?.userAgent || '' : ''
  const matches = userAgent.match(cfIdRegex) || []
  const facilityId = (matches.length === 5 && (matches[2] || matches[4])) || undefined
  return facilityId
}
